import { Dispatch, SetStateAction, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { setCustomer } from 'store/actions';
import { plCustomerSelector } from 'store/selectors';
import { PLCustomerData } from 'types';

import { ErrorType } from '../constants';

import { Address } from './Address';
import { ContactInformation } from './ContactInformation';
import { PersonalInformation } from './PersonalInformation';
import { Remarks } from './Remarks';

type UserDataFormProps = {
	setError: Dispatch<SetStateAction<ErrorType | undefined>>;
	formHook: UseFormReturn;
};

export const UserDataForm = ({ setError, formHook }: UserDataFormProps) => {
	const { register, getValues, setValue, formState, trigger, watch } = formHook;

	const customer = useSelector(plCustomerSelector);
	const dispatch = useDispatch();
	const watchAllFields = watch();

	const fillPreviouslyEnteredFields = () => {
		if (customer) {
			Object.keys(customer).forEach((key) => {
				setValue(key, customer[key as keyof PLCustomerData]);
			});
		}
	};

	useEffect(() => {
		fillPreviouslyEnteredFields();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const { errors, isSubmitted } = formState;
		if (Object.keys(errors).length > 0 && isSubmitted) {
			setError('MISSING_FIELDS_ERROR');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formState]);

	useEffect(() => {
		if (JSON.stringify(watchAllFields) !== JSON.stringify(customer)) {
			dispatch(setCustomer(watchAllFields as PLCustomerData));
		}
		// should only happen when form data changes
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [watchAllFields]);

	return (
		<>
			<PersonalInformation
				register={register}
				setValue={setValue}
				formState={formState}
				trigger={trigger}
			/>

			<Address
				register={register}
				setValue={setValue}
				getValues={getValues}
				formState={formState}
				trigger={trigger}
			/>

			<ContactInformation
				register={register}
				formState={formState}
				setValue={setValue}
				trigger={trigger}
			/>

			<Remarks />
		</>
	);
};
